import React from 'react';
import { RouteObject } from 'react-router-dom';
import {
    parcoursFormaliteBasePath,
    parcoursFormaliteClientsStepPath,
    parcoursFormaliteContactStepPath,
    parcoursFormaliteDocsStepPath,
    parcoursFormaliteFormaliteStepPath,
    parcoursFormaliteFormStepPath,
    parcoursFormaliteNextFormStepPath,
    parcoursFormalitePrescriberStepPath,
    parcoursFormaliteRecapStepPath,
} from './constants';
import ParcoursFormaliteRoot from './ParcoursFormaliteRoot';
import StepSelectionFormalites from './steps/StepSelectionFormalites';
import StepSelectionClient from './steps/StepSelectionClient';
import StepFormulaires from './steps/StepFormulaires';
import StepRecap from './steps/StepRecap';
import StepDocFirst from './steps/StepDocFirst';
import StepNextForm from './steps/StepNextForm';
import StepPrescriber from './steps/StepPrescriber';
import StepContact from './steps/StepContact';

export const ParcoursFormaliteRouter: RouteObject = {
    path: parcoursFormaliteBasePath,
    element: <ParcoursFormaliteRoot />,
    handle: { title: 'Nouveau dossier' },
    children: [
        {
            path: parcoursFormalitePrescriberStepPath,
            element: <StepPrescriber />,
            handle: { title: '(1/3) Sélection du prescripteur - Nouveau dossier' },
        },
        {
            path: parcoursFormaliteContactStepPath,
            element: <StepContact />,
            handle: { title: 'Nouveau dossier - Sélection du contact' },
        },
        {
            path: parcoursFormaliteFormaliteStepPath,
            element: <StepSelectionFormalites />,
            handle: { title: '(2/3) Sélection des formalités - Nouveau dossier' },
        },
        {
            path: parcoursFormaliteClientsStepPath,
            element: <StepSelectionClient />,
            handle: { title: '(3/3) Sélection du client - Nouveau dossier' },
        },
        {
            path: `${parcoursFormaliteFormStepPath}/:indexPresta/:page`,
            element: <StepFormulaires />,
            handle: { title: 'Nouveau dossier - Sélection du formulaire' },
        },
        {
            path: parcoursFormaliteDocsStepPath,
            element: <StepDocFirst />,
            handle: { title: 'Nouveau dossier - Import des fichiers préalables' },
        },
        {
            path: parcoursFormaliteRecapStepPath,
            element: <StepRecap />,
            handle: { title: 'Nouveau dossier - Récapitulatif' },
        },
        {
            path: `${parcoursFormaliteNextFormStepPath}/:indexPresta/:page`,
            element: <StepNextForm />,
            handle: { title: "Nouveau dossier - Création d'un prochain dossier" },
        },
    ],
};

export const ParcoursFormaliteRouterBack: RouteObject = {
    ...ParcoursFormaliteRouter,
    element: <ParcoursFormaliteRoot back />,
};
